import type { ReactNode } from 'react'

import { Popover, PopoverContent, PopoverTrigger } from '@/src/elements/popover'
import { useDimensions } from '@/src/general/hooks/useDimensions'

import { Listbox } from '../listbox'
import { ActionSheetMobile, type TActionSheetProps } from './ActionSheetMobile'
import { useActionSheet } from './useActionSheet'

export const ActionSheet = ({ children, items }: TActionSheetProps): ReactNode => {
  const { lessThan } = useDimensions()
  const { isActionSheetVisible, setIsActionSheetVisible, renderActionItem } = useActionSheet()

  if (lessThan.md) return <ActionSheetMobile items={items}>{children}</ActionSheetMobile>

  return (
    <Popover
      backdrop="opaque"
      placement="bottom"
      isOpen={isActionSheetVisible}
      onOpenChange={(open: boolean) => setIsActionSheetVisible(open)}
      classNames={{ backdrop: 'cursor-pointer' }}
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent className="rounded-lg p-2">
        <Listbox items={items}>{renderActionItem}</Listbox>
      </PopoverContent>
    </Popover>
  )
}
